query allBasketballTeams(
  $first: Int,
  $offset: Int,
  $filter: BasketballTeamFilter,
  ) {
  teams: allBasketballTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
        squad
        shortName
        name
        source
        teamId
        division
        stadium
        city
        state
        mappings: basketballTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingType
        }
      }
    }
    totalCount
  }
}
